<div class="subNavMenu">
  @for (item of subNavMenu; track item; let last = $last) {
    @if (!item.hide) {
      <div class="subNavMenu-item" [ngClass]="{ active: item.isSelected }">
        <a
          class="subNavMenu-item--title"
          [ngClass]="{ active: item.isSelected }"
          (click)="subMenuClick(item)"
        >
          <i class="bi bi-chevron-right sub-chevron" aria-hidden="true"></i>
          <label class="sub-label cursor-select">{{ item.name }}</label>
          @if (item.badgeLabel) {
            <span
              class="subNavMenu-item--badge"
              [ngClass]="item.badgeClassName"
            >
              @if (item.badgeIcon) {
                <i class="bi me-1" [ngClass]="item.badgeIcon"></i>
              }
              {{ item.badgeLabel }}
            </span>
          }
          @if (item.name === 'ADMIN') {
            <i class="bi bi-lock-fill ms-auto sub-lock"></i>
          }
        </a>
        <div
          [ngbCollapse]="!!item.isCollapsed"
          [animation]="true"
          class="subNavMenu-item--content-{{ replaceSpaces(item.name) }}"
        >
          @if (item.subMenu) {
            <app-nav-sub-menu
              (menuSelectionEvent)="menuSelection($event)"
              [subNavMenu]="item.subMenu.menuItems"
            ></app-nav-sub-menu>
          }
        </div>
      </div>
    }
  }
</div>
